module.exports = __webpack_public_path__ + "img/avatar5.9a8d13b2.png";